<div class="offer-area grow">
  @if ((aspectRatio$ | async) && (hotelsImage$ | async)) {
    <section class="destination-image relative">
      <fin-content-image [aspectRatio$]="aspectRatio$" [imageData$]="hotelsImage$"> </fin-content-image>
    </section>
  }

  <fcom-tag class="ms-medium-l ms-medium-t absolute top-left">
    <fcom-icon [name]="SvgLibraryIcon.AVIOS_PLECTRUM" class="icon-small"></fcom-icon>
    <span class="ms-xsmall-l">{{
      'MMB.thirdparty.expedia.nonSupportedLanguageWidget.collectAvios' | finLocalization
    }}</span>
  </fcom-tag>

  <section class="fill ps-medium">
    <h4 class="font-heading-4">
      {{ 'MMB.thirdparty.expedia.nonSupportedLanguageWidget.title' | finLocalization: { cityName: cityName$ | async } }}
    </h4>
    <p class="font-body-1 ms-xsmall-t">
      {{ 'MMB.thirdparty.expedia.nonSupportedLanguageWidget.description' | finLocalization }}
    </p>
    <div class="button-wrapper flex flex--middle flex--space-between flex--nowrap font-body-1 ms-medium-t">
      <div class="flex flex--wrap">
        <div
          class="ps-xxsmall-r"
          [innerHTML]="'MMB.thirdparty.expedia.nonSupportedLanguageWidget.poweredBy' | finLocalization"
        ></div>
        <fcom-icon class="hotels-logo" [category]="IconLibrary.CUSTOM" [name]="CustomIcon.HOTELS_LOGO"></fcom-icon>
      </div>
      <fcom-button
        (clickBtn)="openLegislationModal($event)"
        [text]="'MMB.thirdparty.expedia.nonSupportedLanguageWidget.ctaButton' | finLocalization"
        [icon]="{
          name: SvgLibraryIcon.EXTERNAL_TAB,
          position: IconPosition.RIGHT,
        }"
        [href]="deeplink$ | async"
        [openInNewTab]="true"
        [externalLink]="true"
      ></fcom-button>
    </div>
  </section>
</div>

<fin-mmb-hotel-legislation-modal
  [redirectUrl]="deeplink$ | async"
  [isOpen]="legislationModalOpen"
></fin-mmb-hotel-legislation-modal>
